export default __webpack_public_path__ + "static/eth@2x-c0d6a0c8ba3b6143c1c128bbbe9c4e44.png";